"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.LocalizeMenu = void 0;

var _jquery = babelHelpers.interopRequireDefault(require("jquery"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

function setHeaderLanguageText(text) {
  if (text === 'source') return;
  LocalizeMenu.setHeaderLanguageText(text);
}

var LocalizeMenu =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(LocalizeMenu, _Component);

  function LocalizeMenu() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, LocalizeMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(LocalizeMenu)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.state = {
      headerLanguageText: LocalizeMenu._headerLanguageText,
      visible: LocalizeMenu._visible
    };
    return _this;
  }

  babelHelpers.createClass(LocalizeMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      LocalizeMenu._instances.add(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      LocalizeMenu._instances.delete(this);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.visible) return null;
      return _react.default.createElement("div", {
        id: "localize-menu"
      }, _react.default.createElement("a", {
        className: "localize-label",
        href: "javascript:void(0)",
        "data-toggle": "modal",
        "data-target": "#localize-menu-modal"
      }, this.state.headerLanguageText));
    }
  }], [{
    key: "setHeaderLanguageText",
    value: function setHeaderLanguageText(text) {
      this._headerLanguageText = text;

      this._instances.forEach(function (instance) {
        return instance.setState({
          headerLanguageText: text
        });
      });
    }
  }, {
    key: "localizeInit",
    value: function localizeInit() {
      this._visible = true;

      this._instances.forEach(function (instance) {
        return instance.setState({
          visible: true
        });
      });
    }
  }]);
  return LocalizeMenu;
}(_react.Component);

exports.LocalizeMenu = LocalizeMenu;
LocalizeMenu._instances = new Set();
LocalizeMenu._headerLanguageText = "";
LocalizeMenu._visible = false;

function setup() {
  if (!document.body) {
    (0, _jquery.default)(setup);
    return;
  }

  LocalizeMenu.localizeInit();
  (0, _jquery.default)('body').append("\n\t\t<div id='localize-menu-modal-wrapper' class='modal-wrapper fade'>\n\t\t\t<div id='localize-menu-modal' class='modal modal-full fade' data-backdrop-parent='#localize-menu-modal-wrapper'>\n\t\t\t\t<div class='modal-dialog'>\n\t\t\t\t\t<div class='modal-content'>\n\t\t\t\t\t\t<div class='modal-header'>\n\t\t\t\t\t\t\t".concat(BLX.modalCloseButton(), "\n\t\t\t\t\t\t\t<h4 class='modal-title'></h4>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class='modal-body'>\n\t\t\t\t\t\t\t<div class='container'>\n\t\t\t\t\t\t\t\t<h4>Choose a Language</h4>\n\t\t\t\t\t\t\t\t<div notranslate id='language-select-menu'></div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t"));
  Localize.on('setLanguage', function (_ref) {
    var to = _ref.to;
    setHeaderLanguageText(to.split('-').shift());
    (0, _jquery.default)('#language-select-menu a').removeClass('localize-selected');
    (0, _jquery.default)("#language-select-menu a[data-code=\"".concat(to, "\"]")).addClass('localize-selected');
  });
  Localize.getAvailableLanguages(function (err, lang) {
    if (err) return;
    setHeaderLanguageText(Localize.getLanguage());
    var links = lang.map(function (language) {
      var l = document.createElement('a');
      l.href = 'javascript:void(0)';
      l.addEventListener('click', function () {
        Localize.setLanguage(language.code);
        (0, _jquery.default)('#localize-menu-modal').modal('hide');
        return false;
      });
      l.dataset.code = language.code;
      l.className = 'localize-item';
      l.innerHTML = "\n\t\t\t\t<span class='language-code'></span>\n\t\t\t\t<span class='language-title'></span>\n\t\t\t\t<span class='language-selected-check'><span class='material-icons' data-icon='check'></span></span>\n\t\t\t";
      l.querySelector('.language-code').textContent = language.code.split('-').shift();
      l.querySelector('.language-title').textContent = language.name;
      return l;
    });
    links.forEach(function (link) {
      return document.querySelector('#language-select-menu').appendChild(link);
    });
  });
}

function init() {
  if (window.Localize) {
    if (Localize.loaded) setup();else Localize.on('initialize', setup);
  }
}